import { get } from '../api';

const route = '/search';

const getSearch = ({ allSearchParams = '', config }) => get(`${route}/?${allSearchParams}`, config);

export default getSearch;
